module.exports = __webpack_public_path__ + "static/media/logo.ba4e73db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/logo.svg
// module id = 928
// module chunks = 53